module.exports = __webpack_public_path__ + "static/the-robber-barons-d38f1e5ac08dd3146c0748d0a63405cb.jpg";